import QueryString from 'query-string';
import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import LoadingProgress from '../../components/LoadingProgess';
import { OFFLINE_LESSON_SERVER } from '../../env/variables';
import { setOfflineMode } from '../../store/actions/resources.actions';
import { RESOURCE_LOADED_STATUS } from '../../store/sagas/resources.saga';
import Catiz3 from '../Catiz3';
import CatizTouchPanel from '../Catiz3/TouchPanel';
import Hermesys from '../Hermesys';
import { HermsysMain } from '../Hermesys/main';
import S80 from '../S80';

const LessonLauncherOffline: React.FC = () => {
    const resourcesLoadingStatus = useSelector((state: any) => state.resources.loadingStatus);
    const location = useLocation();
    const { unit, version, system, subsystem } = QueryString.parse(location.search);
    const dispatch = useDispatch();
    const executorResources = useSelector((state: any) => state.resources);
    const { t } = useTranslation();
    const lessonDef = executorResources.lessonDefinition;

    useEffect(() => {
        dispatch(setOfflineMode(true));
        fetch(`${OFFLINE_LESSON_SERVER}/api/lessons/${unit}/player/${version}`)
            .then((res) => res.json())
            .then((data) => {
                dispatch({ type: 'SET_RESOURCES_FROM_API', payload: data });
                dispatch({ type: 'RESOURCES_LOADING_FOR_LESSON_SUCCESS', payload: data.resources.lessonDefinition.id });
            });
    }, [unit, version]);

    if (!lessonDef || !resourcesLoadingStatus[lessonDef.id]) {
        return <LoadingProgress message={t('loadingProgress.player')} />;
    }
    if (resourcesLoadingStatus[lessonDef.id] === RESOURCE_LOADED_STATUS.FAILED) {
        return <p>Failed loading resources</p>;
    }
    return (
        <Fragment>
            {system === 's80' && <S80 />}
            {system === 'catiz3' && subsystem === 'touchpanel' && <CatizTouchPanel />}
            {system === 'catiz3' && subsystem !== 'touchpanel' && <Catiz3 />}
            {system === 'hermesys' && <Hermesys />}
        </Fragment>
    );
};

export default LessonLauncherOffline;
